<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn" style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close>
      <span class="material-symbols-outlined">close</span>
    </div>

    @if (step == 1 && solicitar_solo_clave == false) {
      <h1 style="text-align: center;" class="titulo-simpli">Ingresa la clave SII de tu empresa </h1>
    }
    @if (step == 1 && solicitar_solo_clave == false) {
      <small style="display: block;text-align: center;" class="subtitulo-simpli">Completa este paso para evitar errores<br> de autenticación al ceder.</small>
    }

    @if (step == 2 && files.length == 0 && solicitar_solo_clave == false) {
      <h1 style="text-align: center;" class="titulo-simpli">Ingresa las credenciales autorizadas</h1>
    }
    @if (step == 2 && files.length == 0 && solicitar_solo_clave == false) {
      <small style="display: block;text-align: center;position: relative;" class="subtitulo-simpli">
        Agrega los datos de una persona que esté autorizada<br>a realizar la cesión con los AEC.
        <span style="margin-left: 10px;font-size: 20px;color:#924eff;" [mdePopoverTriggerFor]="appPopovertable2" mdePopoverTriggerOn="hover" #popoverTriggerClose="mdePopoverTrigger"><span class="material-symbols-outlined">enhanced_encryption</span></span>
        <mde-popover #appPopovertable2="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
          <mat-card class="popover-card" style="max-width: 370px;position: relative;">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="row-detail-popover" style="font-weight: bold;">Tus datos están protegidos por nuestra politica de privacidad.</div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 20px;margin-bottom: 10px;">
                <div class="row-detail-popover"><a style="color:white;" href="https://simplilatam.com/politica-de-privacidad/" target="blank">Ver politica de privacidad <span><span class="material-symbols-outlined" style="margin-left: 10px;">chevron_right</span></span></a></div>
              </div>
            </div>
          </mat-card>
        </mde-popover>
      </small>
    }

    @if (step == 2 && files.length > 0 && solicitar_solo_clave == false) {
      <h1 style="text-align: center;" class="titulo-simpli">Ingresa la clave del Certificado Digital </h1>
    }
    @if (step == 2 && files.length > 0 && solicitar_solo_clave == false) {
      <small style="display: block;text-align: center;" class="subtitulo-simpli">Estas a un paso de completar la validación de indentidad.</small>
    }

    @if (solicitar_solo_clave == true && step == 0) {
      <h1 style="text-align: center;" class="titulo-simpli">Ingresa la clave de acceso al SII</h1>
    }
    @if (solicitar_solo_clave == true && step == 0) {
      <small style="display: block;text-align: center;" class="subtitulo-simpli">Este dato es necesario para realizar la cesión con los AEC.</small>
    }

    @if (step == 3) {
      <h1 style="text-align: center;" class="titulo-simpli">Ingresa la clave del Certificado Digital</h1>
    }
    @if (step == 3) {
      <small style="display: block;text-align: center;" class="subtitulo-simpli">Este dato es necesario para realizar la cesión con los AEC.</small>
    }

    @if (step == 0 && solicitar_solo_clave == false) {
      <h1 style="text-align: center;" class="titulo-simpli">Elige cómo vas a acceder</h1>
    }
    @if (step == 0 && solicitar_solo_clave == false) {
      <small style="display: block;text-align: center;" class="subtitulo-simpli">Puedes acceder como empresa o persona natural.</small>
    }

  </div>
</div>



<mat-dialog-content style="min-height: 445px;">

  <!--clave sii-->
  @if (step == 1 && solicitar_solo_clave == false) {
    <div style="text-align: center;">
      <form  [formGroup]="valForm" style="margin-top: 30px;margin-bottom: 30px;">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <mat-form-field appearance="fill"  style="position: relative;">
              <mat-label>Clave SII</mat-label>
              <input formControlName="sii_pass" matInput type="password" required >
              <mat-hint>Ingresa la clave de acceso al SII (clave tributaria) <strong>de la empresa.</strong></mat-hint>
              @if (valForm.controls['sii_pass'].hasError('incorrect')) {
                <mat-error>
                  La clave ingresada no es válida.
                </mat-error>
              }
              @if (valForm.controls['sii_pass'].hasError('bloqueada')) {
                <mat-error>
                  Clave SII bloqueada.
                </mat-error>
              }
              @if (valForm.controls['sii_pass'].hasError('required')) {
                <mat-error>
                  Clave SII es requerida.
                </mat-error>
              }
              @if (loading_sii == false) {
                <span matSuffix class="icon-credencial" [mdePopoverTriggerFor]="appPopovertable" mdePopoverTriggerOn="hover" #popoverTriggerClose="mdePopoverTrigger">
                  <span class="material-symbols-outlined">enhanced_encryption</span>
                </span>
              }
              @if (loading_sii == true) {
                <span matSuffix class="icon-credencial">
                  <span class="material-symbols-outlined mat-spin">progress_activity</span>
                </span>
              }
            </mat-form-field>
            <mde-popover #appPopovertable="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
              <mat-card class="popover-card" style="max-width: 370px;position: relative;">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row-detail-popover" style="font-weight: bold;">Tus datos están protegidos por nuestra politica de privacidad.</div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 20px;margin-bottom: 10px;">
                    <div class="row-detail-popover"><a style="color:white;" href="https://simplilatam.com/politica-de-privacidad/" target="blank">Ver politica de privacidad <span><span class="material-symbols-outlined" style="margin-left: 10px;">chevron_right</span></span></a></div>
                  </div>
                </div>
              </mat-card>
            </mde-popover>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="btn-simpli-container" style="margin-top: 140px;">
              <button [disabled]="loading_sii" class="primary-button" mat-flat-button (click)="post_credenciales($event, valForm.value)">
                @if (!loading_sii) {
                  <span>Continuar</span>
                }
                @if (loading_sii) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:white;">progress_activity</span></span>
                }
              </button>
              <button class="secondary-button" mat-flat-button mat-dialog-close >
                Volver
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  }

  <!--certificado-->
  @if (step == 2 && solicitar_solo_clave == false) {
    <div style="text-align: center;">
      <form  [formGroup]="valFormCertificado" style="margin-top: 30px;margin-bottom: 30px;">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <mat-form-field color="primary" appearance="fill" style="position: relative;">
              <mat-label>9999999-K</mat-label>
              <input required matInput formControlName="rut_autorizado" (keyup)="rutKey($event)"  type="text">
              <mat-hint>Ingresa el RUT de la persona autorizada por la empresa</mat-hint>
              @if (valFormCertificado.controls['rut_autorizado'].hasError('incorrect')) {
                <mat-error>
                  Rut autorizado es inválido.
                </mat-error>
              }
              @if (valFormCertificado.controls['rut_autorizado'].hasError('required')) {
                <mat-error>
                  Rut autorizado requerido.
                </mat-error>
              }
              <span matSuffix class="icon-credencial">
                <span class="material-symbols-outlined">info</span>
              </span>
            </mat-form-field>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <mat-form-field color="primary" appearance="fill" style="position: relative;">
              <mat-label>Agregar Certificado Digital</mat-label>
              <input required matInput formControlName="file" readonly (click)="triger_click()" style="cursor: pointer;" >
              <mat-hint>Solo se admite el formato ".pfx" y un peso menor a "50MB".</mat-hint>
              @if (valFormCertificado.controls['file'].hasError('incorrect')) {
                <mat-error>
                  El Certificado Digital es inválido.
                </mat-error>
              }
              @if (valFormCertificado.controls['file'].hasError('required')) {
                <mat-error>
                  El Certificado Digital es requerido.
                </mat-error>
              }
              @if (files.length == 0) {
                <span matSuffix class="icon-credencial">
                  <span class="material-symbols-outlined">attach_file</span>
                </span>
              }
              @if (files.length > 0) {
                <span style="cursor: pointer;" (click)="deleteFile()" matSuffix class="icon-credencial">
                  <span class="material-symbols-outlined">delete</span>
                </span>
              }
            </mat-form-field>
            <input type="file" accept=".pfx" (change)="handleFiles($event.target.files)" style="display: none;" id="fileInput2" #fileInput2 />
          </div>
          @if (files.length > 0) {
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
              <mat-form-field appearance="fill"  style="position: relative;">
                <mat-label>Clave Certificado Digital</mat-label>
                <input formControlName="cert_pass" matInput type="password" required >
                <mat-hint>Ingresa la clave de acceso al SII (clave tributaria)</mat-hint>
                @if (valFormCertificado.controls['cert_pass'].hasError('incorrect')) {
                  <mat-error>
                    La clave ingresada no es válida.
                  </mat-error>
                }
                @if (valFormCertificado.controls['cert_pass'].hasError('required')) {
                  <mat-error>
                    La Clave del Certificado Digital es requerida.
                  </mat-error>
                }
                <span matSuffix class="icon-credencial" [mdePopoverTriggerFor]="appPopovertable3" mdePopoverTriggerOn="hover" #popoverTriggerClose="mdePopoverTrigger">
                  <span class="material-symbols-outlined">enhanced_encryption</span>
                </span>
              </mat-form-field>
              <mde-popover #appPopovertable3="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
                <mat-card class="popover-card" style="max-width: 370px;position: relative;">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="row-detail-popover" style="font-weight: bold;">Tus datos están protegidos por nuestra politica de privacidad.</div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 20px;margin-bottom: 10px;">
                      <div class="row-detail-popover"><a style="color:white;" href="https://simplilatam.com/politica-de-privacidad/" target="blank">Ver politica de privacidad <span><span class="material-symbols-outlined" style="margin-left: 10px;">chevron_right</span></span></a></div>
                    </div>
                  </div>
                </mat-card>
              </mde-popover>
            </div>
          }
          @if (files.length > 0) {
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
              <div style="color: #924eff;margin-top: 15px;cursor: pointer;">
                <span style="color:#924eff;margin-right: 10px;"><span class="material-symbols-outlined">info</span></span>
                <span [mdePopoverTriggerFor]="appPopovertable6" mdePopoverTriggerOn="click" #popoverTriggerClose="mdePopoverTrigger">¿Cómo recuperar la clave del Certificado?</span>
                <mde-popover #appPopovertable6="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
                  <mat-card class="popover-card" style="max-width: 370px;position: relative;">
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="row-detail-popover">Solicita la ayuda de tu contador para acceder <br> a ella o adquiere un nuevo certificado.</div>
                      </div>
                    </div>
                  </mat-card>
                </mde-popover>
              </div>
              <section class="example-section" style="margin-top: 20px;">
                <mat-checkbox color="primary" class="example-margin" formControlName="need_saved">
                  Autorizo la <span style="color: #924eff;text-decoration: underline;" (click)="open_sincronizacion($event)">sincronización de credenciales</span>
                </mat-checkbox>
              </section>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="btn-simpli-container">
              @if (files.length == 0) {
                <button class="primary-button" mat-flat-button  style="background: #adadad !important;color:white;border: solid 1px gray;">
                  Adjuntar Certificado
                </button>
              }
              @if (files.length > 0) {
                <button [disabled]="loading_upload" (click)="post_certificado($event, valFormCertificado.value)" class="primary-button" mat-flat-button  >
                  @if (!loading_upload) {
                    <span>Generar AEC</span>
                  }
                  @if (loading_upload) {
                    <span><span class="material-symbols-outlined mat-spin" style="color:white;">progress_activity</span></span>
                  }
                </button>
              }
            </div>
          </div>
          @if (files.length == 0) {
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <a style="color:#924eff;text-decoration: underline;cursor: pointer;" (click)="que_es_un_adc()">Prefiero cargar los AEC desde mi equipo</a>
            </div>
          }
        </div>
      </form>
    </div>
  }

  <!--solo clave sii-->
  @if (solicitar_solo_clave == true || step == 0) {
    <div style="text-align: center;">
      <form  [formGroup]="valFormClave" style="margin-top: 30px;margin-bottom: 30px;min-height: 330px;">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <mat-form-field appearance="fill"  style="position: relative;">
              <mat-label>Clave SII</mat-label>
              <input formControlName="sii_pass" matInput type="password" required >
              <mat-hint>Ingresa la clave de acceso al SII (clave tributaria)</mat-hint>
              @if (valFormClave.controls['sii_pass'].hasError('incorrect')) {
                <mat-error>
                  La clave ingresada no es válida.
                </mat-error>
              }
              @if (valFormClave.controls['sii_pass'].hasError('bloqueada')) {
                <mat-error>
                  Clave SII bloqueada.
                </mat-error>
              }
              @if (valFormClave.controls['sii_pass'].hasError('required')) {
                <mat-error>
                  Clave SII es requerida.
                </mat-error>
              }
              @if (loading_sii == false) {
                <span matSuffix class="icon-credencial" [mdePopoverTriggerFor]="appPopovertable" mdePopoverTriggerOn="hover" #popoverTriggerClose="mdePopoverTrigger">
                  <span class="material-symbols-outlined">enhanced_encryption</span>
                </span>
              }
              @if (loading_sii == true) {
                <span matSuffix class="icon-credencial">
                  <span class="material-symbols-outlined mat-spin">progress_activity</span>
                </span>
              }
            </mat-form-field>
            <mde-popover #appPopovertable="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
              <mat-card class="popover-card" style="max-width: 370px;position: relative;">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row-detail-popover" style="font-weight: bold;">Tus datos están protegidos por nuestra politica de privacidad.</div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 20px;margin-bottom: 10px;">
                    <div class="row-detail-popover"><a style="color:white;" href="https://simplilatam.com/politica-de-privacidad/" target="blank">Ver politica de privacidad <span><span class="material-symbols-outlined" style="margin-left: 10px;">chevron_right</span></span></a></div>
                  </div>
                </div>
              </mat-card>
            </mde-popover>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="margin-top: 40px;">
            <section class="example-section" style="margin-top: 20px;">
              <mat-checkbox color="primary" class="example-margin" formControlName="need_saved">
                Autorizo la <span style="color: #924eff;text-decoration: underline;" (click)="open_sincronizacion($event)">sincronización de credenciales</span>
              </mat-checkbox>
            </section>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="btn-simpli-container" style="margin-top: 80px;">
              <button [disabled]="loading_sii" class="primary-button" mat-flat-button (click)="post_credenciales_only_pass($event, valFormClave.value)">
                @if (!loading_sii) {
                  <span>Continuar</span>
                }
                @if (loading_sii) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:white;">progress_activity</span></span>
                }
              </button>
              <button class="secondary-button" mat-flat-button mat-dialog-close >
                Volver
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  }

  <!--solo clave certificado-->
  @if (step == 3) {
    <div style="text-align: center;">
      <form  [formGroup]="valFormClaveCert" style="margin-top: 30px;margin-bottom: 30px;min-height: 330px;">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <mat-form-field appearance="fill"  style="position: relative;">
              <mat-label>Clave Certificado Digital</mat-label>
              <input formControlName="cert_pass" matInput type="password" required >
              <mat-hint>Ingresa la clave de acceso al SII (clave tributaria)</mat-hint>
              @if (valFormClaveCert.controls['cert_pass'].hasError('incorrect')) {
                <mat-error>
                  La clave ingresada no es válida.
                </mat-error>
              }
              @if (valFormClaveCert.controls['cert_pass'].hasError('required')) {
                <mat-error>
                  La Clave del Certificado Digital es requerida.
                </mat-error>
              }
              <span matSuffix class="icon-credencial" [mdePopoverTriggerFor]="appPopovertable7" mdePopoverTriggerOn="hover" #popoverTriggerClose="mdePopoverTrigger">
                <span class="material-symbols-outlined">enhanced_encryption</span>
              </span>
            </mat-form-field>
            <mde-popover #appPopovertable7="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
              <mat-card class="popover-card" style="max-width: 370px;position: relative;">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row-detail-popover" style="font-weight: bold;">Tus datos están protegidos por nuestra politica de privacidad.</div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 20px;margin-bottom: 10px;">
                    <div class="row-detail-popover"><a style="color:white;" href="https://simplilatam.com/politica-de-privacidad/" target="blank">Ver politica de privacidad <span><span class="material-symbols-outlined" style="margin-left: 10px;">chevron_right</span></span></a></div>
                  </div>
                </div>
              </mat-card>
            </mde-popover>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="margin-top: 40px;">
            <section class="example-section" style="margin-top: 20px;">
              <mat-checkbox color="primary" class="example-margin" formControlName="need_saved">
                Autorizo la <span style="color: #924eff;text-decoration: underline;" (click)="open_sincronizacion($event)">sincronización de credenciales</span>
              </mat-checkbox>
            </section>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <div style="color: #924eff;margin-top: 15px;cursor: pointer;">
              <span style="color:#924eff;margin-right: 10px;"><span class="material-symbols-outlined">info</span></span>
              <span [mdePopoverTriggerFor]="appPopovertable6" mdePopoverTriggerOn="click" #popoverTriggerClose="mdePopoverTrigger">¿Cómo recuperar la clave del Certificado?</span>
              <mde-popover #appPopovertable6="mdePopover" [mdePopoverOverlapTrigger]="false" [mdePopoverCloseOnClick]="false">
                <mat-card class="popover-card" style="max-width: 370px;position: relative;">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="row-detail-popover">Solicita la ayuda de tu contador para acceder <br> a ella o adquiere un nuevo certificado.</div>
                    </div>
                  </div>
                </mat-card>
              </mde-popover>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="btn-simpli-container" style="margin-top: 80px;">
              <button [disabled]="loading_pass_cert" class="primary-button" mat-flat-button (click)="post_credenciales_only_pass_cert($event, valFormClaveCert.value)">
                @if (!loading_pass_cert) {
                  <span>Generar AEC</span>
                }
                @if (loading_pass_cert) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:white;">progress_activity</span></span>
                }
              </button>
              <button class="secondary-button" mat-flat-button mat-dialog-close >
                Volver
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  }



</mat-dialog-content>
